import { LinkedInvoiceWidget } from 'Integrations/integrationsConfig/common/LinkEntities/LinkedInvoiceWidget/LinkedInvoiceWidget'
import { FC } from 'react'

export const LinkSalesforceInvoiceWidget: FC<{
  invoiceId: string
}> = props => (
  <LinkedInvoiceWidget invoiceId={props.invoiceId} service="Salesforce" />
)
